import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { BaseAddonService } from '@src/framework/workbench/common/service/base-addon-service';
import i18n from '@i18next/i18n';

@Feature()
export class InsertLatexFeature extends BaseToolbarFeature {
    id = ActionType.INSERT_WITH_LATEX;
    constructor() {
        super();
    }

    public getContent() {
        return i18n.t(BaseAddonService.addonInfoMap[ActionType.INSERT_WITH_LATEX]?.name ?? '');
    }

    public onClick() {
        const addonId = BaseAddonService.addonInfoMap[ActionType.INSERT_WITH_LATEX]?.addonId;
        if (!addonId) return;
        this.getMenuManager()?.toolbarMenu()
            ?.callback(
                'TOOLBAR',
                ActionType.INSERT_WITH_LATEX,
                `${addonId}_0`,
            );
    }

    protected getCustomDisabledState(): boolean {
        return this.shouldDisableInMaster(this.id);
    }
}
